import * as Sentry from '@sentry/react';
import Ambiente, { TIPO_AMBIENTE } from './Ambiente';
import Configuracao from './Configuracao';

/**
 * @classdesc Agrupa métodos para auxiliar na manipulação do Sentry.
 */
class SentryUtil {
    static #instance = null;

    constructor() {
        if (SentryUtil.#instance) {
            throw new Error('Deve existir apenas uma instância.');
        }

        SentryUtil.#instance = this;
    }

    static inicializar() {
        return SentryUtil.#initSentry();
    }

    static #initSentry() {
        if (!Configuracao.HABILITAR_SENTRY) {
            console.info('Sentry desabilitado.');
            return false;
        }

        if (Ambiente.isSentryInicializado()) {
            console.info('Sentry já inicializado.');
            return true;
        }

        const backend = Ambiente.getEnvBackend();
        let envName = backend.substring(backend.indexOf('/') + 2);
        envName = envName.substring(0, envName.indexOf('/'));

        const buildInfo = Ambiente.getBuildInfo();
        // @ts-ignore
        const versaoApp = buildInfo ? buildInfo.versaoAplicacao : '';

        if (
            envName.includes('.tst') &&
            !window.location.hostname.startsWith('local') &&
            !window.location.hostname.startsWith('plenariodev')
        ) {
            Sentry.init({
                dsn: 'https://3728fb15ab4c4117b17d19ab73819083@sentry.tst.jus.br/13',
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.replayIntegration({
                        maskAllText: false,
                        maskAllInputs: false,
                        blockAllMedia: false
                    }),
                    Sentry.captureConsoleIntegration({
                        levels: ['warn', 'error']
                    })
                ],
                tracePropagationTargets: SentryUtil.getPropagationTargets(),
                tracesSampleRate: 1.0,
                replaysSessionSampleRate: Ambiente.getDescricao() === TIPO_AMBIENTE.PRD.descricao ? 0.1 : 1.0,
                replaysOnErrorSampleRate: 1.0,
                environment: Ambiente.getId(),
                release: `${Configuracao.PROJECT_NAME}@${versaoApp}`
            });

            console.info(
                `Sentry inicializado para ${envName} com requisições partindo de ${window.location.hostname}.`
            );
            return true;
        }

        console.info(
            `Sentry NÃO inicializado para ${envName} com requisições partindo de ${window.location.hostname}.`
        );
        return false;
    }

    static setScope() {
        if (Ambiente.isSentryInicializado()) {
            const tags = Ambiente.getApmVars().getAllTags();

            if (tags !== null) {
                const scope = Sentry.getCurrentScope();
                scope.setTags(tags);
            }
        }
    }

    static getPropagationTargets() {
        const propagationTargets = [];

        for (const backend of Ambiente.getBackends()) {
            if (backend) {
                propagationTargets.push(backend);
            }
        }

        return propagationTargets;
    }

    /**
     * Identifica o usuário para o Sentry.
     *
     * @param {object} user Objeto com as informações do usuário
     */
    static setSentryUser(user) {
        if (!Ambiente.isSentryInicializado()) {
            console.info('Sentry.setUser ignorado pois o Sentry não foi inicializado.');
            return;
        }

        Sentry.setUser({
            id: user.id ? user.id : Ambiente.INFORMACAO_DESCONHECIDA,
            localizacao: user.localizacao ? user.localizacao : Ambiente.INFORMACAO_DESCONHECIDA,
            username: user.username ? user.username : Ambiente.INFORMACAO_DESCONHECIDA,
            nome: user.nome ? user.nome : Ambiente.INFORMACAO_DESCONHECIDA
        });

        console.info(`SentryUser [id:${user.id} | localizacao:${user.localizacao}].`);
    }
}

export default SentryUtil;
